module.exports = __webpack_public_path__ + "img/bust.db20480d.png";